import type { ReactNode } from "react";

type Props = { className?: string };
const Glyph = ({ children, className = "" }: { children: ReactNode; className?: string }) => (
  <span className={`lite-icon ${className}`.trim()} aria-hidden="true">{children}</span>
);

export const HiArrowRight = (_props: Props) => <Glyph>→</Glyph>;
export const HiArrowLeft = (_props: Props) => <Glyph>←</Glyph>;
export const HiOutlineArrowUpRight = (_props: Props) => <Glyph>↗</Glyph>;
export const HiOutlineArrowTrendingUp = (_props: Props) => <Glyph>↗</Glyph>;
export const HiOutlineCheckCircle = (_props: Props) => <Glyph>✓</Glyph>;
export const HiOutlineCheckBadge = (_props: Props) => <Glyph>✓</Glyph>;
export const HiOutlineBars3 = (_props: Props) => <Glyph>☰</Glyph>;
export const HiOutlineXMark = (_props: Props) => <Glyph>×</Glyph>;
export const HiChevronDown = (_props: Props) => <Glyph>⌄</Glyph>;
export const HiOutlineCodeBracket = (_props: Props) => <Glyph>&lt;/&gt;</Glyph>;
export const HiOutlineCommandLine = (_props: Props) => <Glyph>&gt;_</Glyph>;
export const HiOutlineGlobeAlt = (_props: Props) => <Glyph>◎</Glyph>;
export const HiOutlineSparkles = (_props: Props) => <Glyph>✦</Glyph>;
export const HiOutlineDevicePhoneMobile = (_props: Props) => <Glyph>▯</Glyph>;
export const HiOutlinePaintBrush = (_props: Props) => <Glyph>✎</Glyph>;
export const HiOutlineCloud = (_props: Props) => <Glyph>☁</Glyph>;
export const HiOutlineCpuChip = (_props: Props) => <Glyph>▦</Glyph>;
export const HiOutlineShoppingBag = (_props: Props) => <Glyph>□</Glyph>;
export const HiOutlineUserGroup = (_props: Props) => <Glyph>◉</Glyph>;
export const HiOutlineLightBulb = (_props: Props) => <Glyph>✦</Glyph>;
export const HiOutlinePuzzlePiece = (_props: Props) => <Glyph>◇</Glyph>;
export const HiOutlineShieldCheck = (_props: Props) => <Glyph>✓</Glyph>;
export const HiOutlineEnvelope = (_props: Props) => <Glyph>@</Glyph>;
export const HiOutlineMapPin = (_props: Props) => <Glyph>⌖</Glyph>;
export const HiOutlinePhone = (_props: Props) => <Glyph>☎</Glyph>;
export const FaLinkedinIn = (_props: Props) => <Glyph>in</Glyph>;
export const FaXTwitter = (_props: Props) => <Glyph>X</Glyph>;
